var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app p-0 m-0"},[_c('div',[_c('MainMenu'),_c('PopUp')],1),_c('div',{staticClass:"main pt-5"},[_c('router-view',{staticClass:"page-wrapper"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }